import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { CatalogosProvider } from './context/CatalogosContext';
import { SkinProvider } from './context/SkinContext';
import { Toaster } from 'sonner';
import DynamicHead from './components/DynamicHead';
import Login from './pages/Login';
import DashboardLayout from './layouts/DashboardLayout';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import PostventaRetiredPage from './pages/PostventaRetiredPage';
import Usuarios from './pages/Usuarios';
import Roles from './pages/Roles';
import AdminSeguridad from './pages/AdminSeguridad';
import Menus from './pages/Menus';
import ConfiguracionGeneral from './pages/ConfiguracionGeneral';
import Proyectos from './pages/Proyectos';
import Proveedores from './pages/Proveedores';
import Perfil from './pages/Perfil';
import Auditoria from './pages/Auditoria';
import Notificaciones from './pages/Notificaciones';
import Parametros from './pages/Parametros';
import Integraciones from './pages/Integraciones';
import IntegracionConfig from './pages/IntegracionConfig';
import Plugins from './pages/Plugins';
import PluginPage from './pages/PluginPage';
import Hitos from './pages/Hitos';
import HitoDetalle from './pages/HitoDetalle';
import AdendasAcumulativas from './pages/AdendasAcumulativas';
import ChatbotComercial from './pages/ChatbotComercial';
import AnalisisVentas from './pages/AnalisisVentas';
import LeccionesAprendidasList from './pages/LeccionesAprendidas';
import LeccionDetalle from './pages/LeccionesAprendidas/LeccionDetalle';
import LeccionesAprendidasDashboard from './pages/LeccionesAprendidas/Dashboard';
import LeccionesAprendidasTopLectores from './pages/LeccionesAprendidas/TopLectores';
import './App.css';

function App() {
  return (
    <SkinProvider defaultSkin="warm-professional">
    <AuthProvider>
      <NotificationProvider>
        <CatalogosProvider>
          <DynamicHead />
          <BrowserRouter>
            <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/ibc" element={<Login />} />
            <Route path="/" element={<DashboardLayout />}>
              <Route index element={<Navigate to="/home" replace />} />
              <Route path="home" element={<Home />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="solicitudes" element={<PostventaRetiredPage />} />
              <Route path="solicitudes/*" element={<PostventaRetiredPage />} />
              <Route path="configuracion" element={<PostventaRetiredPage />} />
              <Route path="configuracion/*" element={<PostventaRetiredPage />} />
              <Route path="usuarios" element={<Usuarios />} />
              <Route path="roles" element={<Roles />} />
              <Route path="admin/seguridad" element={<AdminSeguridad />} />
              <Route path="menus" element={<Menus />} />
            <Route path="configuracion-general" element={<ConfiguracionGeneral />} />
              <Route path="proyectos" element={<Proyectos />} />
              <Route path="proveedores" element={<Proveedores />} />
              <Route path="perfil" element={<Perfil />} />
            <Route path="auditoria" element={<Auditoria />} />
            <Route path="notificaciones" element={<Notificaciones />} />
            <Route path="parametros" element={<Parametros />} />
            <Route path="integraciones" element={<Integraciones />} />
            <Route path="integraciones/nueva" element={<IntegracionConfig />} />
            <Route path="integraciones/:codigo" element={<IntegracionConfig />} />
            <Route path="plugins" element={<Plugins />} />
            <Route path="hitos" element={<Hitos />} />
            <Route path="hitos/nuevo" element={<HitoDetalle />} />
            <Route path="hitos/:id" element={<HitoDetalle />} />
            <Route path="plugin/experiencia-adendas" element={<AdendasAcumulativas />} />
            <Route path="chatbot-comercial" element={<ChatbotComercial />} />
            <Route path="analisis-ventas" element={<AnalisisVentas />} />
            <Route path="lecciones-aprendidas" element={<LeccionesAprendidasList />} />
            <Route path="lecciones-aprendidas/dashboard" element={<LeccionesAprendidasDashboard />} />
            <Route path="lecciones-aprendidas/lectores" element={<LeccionesAprendidasTopLectores />} />
            <Route path="lecciones-aprendidas/nuevo" element={<LeccionDetalle />} />
            <Route path="lecciones-aprendidas/:id" element={<LeccionDetalle />} />
            <Route path="constructora/calidad/lecciones-aprendidas" element={<LeccionesAprendidasList />} />
            <Route path="constructora/calidad/lecciones-aprendidas/dashboard" element={<LeccionesAprendidasDashboard />} />
            <Route path="constructora/calidad/lecciones-aprendidas/lectores" element={<LeccionesAprendidasTopLectores />} />
            <Route path="constructora/calidad/lecciones-aprendidas/nuevo" element={<LeccionDetalle />} />
            <Route path="constructora/calidad/lecciones-aprendidas/:id" element={<LeccionDetalle />} />
            <Route path="plugin/*" element={<PluginPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
        </CatalogosProvider>
      </NotificationProvider>
    </AuthProvider>
    </SkinProvider>
  );
}

export default App;
